// The text Chrome, Safari and Firefox give a fetch that got no answer at all
// (the visitor's connection dropped, or the tab was closed). That is the same
// case isNetworkError treats as a warning for our API client, so it should not
// page Sentry when some other script on the page leaves it unhandled. Anchored,
// so "Failed to fetch dynamically imported module" (a broken deploy) still
// reports.
export const BROWSER_NETWORK_ERROR =
  /^TypeError: (Failed to fetch|Load failed|NetworkError when attempting to fetch resource\.)( \([^()]*\))?$/;
